module.exports = __webpack_public_path__ + "static/media/tape.ca8a9c22.jpg";